import { PutResponse } from '@customTypes/api/Notification';
import { Endpoints, ServiceAPI } from '@service/index';
import { useMutation } from 'react-query';

const usePutNotificationRead = () => {
  return useMutation((notificationId: string) => {
    return ServiceAPI.put<null, PutResponse>(
      Endpoints.NotificationRead(notificationId),
    );
  });
};

export default usePutNotificationRead;
